import { motion } from 'motion/react';

interface FadeUpEntryProps {
  children: React.ReactNode;
  threshold?: number;
  delay?: number;
}

export function FadeUpEntry({ children, threshold = 0.3, delay = 1.7 }: FadeUpEntryProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 54 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: threshold }}
      transition={{ duration: 1.2, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
